// src/components/ads/AdManager/AdManager.jsx
import React, { useEffect, useRef } from "react";
import { useAdContext } from "../adContext/adContext";
import "./adManager.css";
import { Carousel } from "../../../components/common/utils/antd-imports/AntdImports.js";
import { API_BASE_URL_IMAGE } from "../../../services/common.js";
import { Image } from "../../../components/common/utils/antd-imports/AntdImports.js";

const AdManager = ({ placementName, className = "", width, height }) => {
  const { adsList } = useAdContext();
  const contentStyle = {
    margin: 0,
    height: "284px",
    width: "284px",
    color: "#fff",
    lineHeight: "344px",
    textAlign: "center",
    background: "#D9D9D9",
  };

  const listStyle = {
    width: "950px",
    height: "152px",
  };

  const mobileStyle = {
    width: "100%",
    textAlign: "center",
    background: "#D9D9D9",
  };

  const getImageStyle = () => {
    if (width && height) {
      return {
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
      };
    }
    if (placementName == "mobile") {
      return mobileStyle;
    }
    if (placementName === "left") {
      return contentStyle;
    }
    return listStyle;
  };
  const filterAds = adsList?.filter((ad) => {
    if (ad?.position_name && typeof ad?.position_name == "string") {
      return ad?.position_name?.toLowerCase().includes(placementName);
    }
  });
  return (
    <div className={`ad-manager ${className}`} style={height ? { height } : {}}>
      <div
        style={height ? { width: "100%", height: "100%" } : { width: "100%" }}
      >
        <Carousel
          arrows={true}
          infinite={true}
          autoplay={true}
          autoplaySpeed={5000}
        >
          {filterAds?.map((ad, index) => {
            const imageStyle = getImageStyle();
            return (
              <div key={index}>
                <a target="_blank" href={ad.ad_url}>
                  <Image
                    style={imageStyle}
                    src={`${API_BASE_URL_IMAGE}${ad.ad_image}`}
                    preview={false}
                  />
                </a>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default AdManager;
